import type { SupportedLanguage } from 'i18n';

export enum ApiLanguages {
  EN = 'EN',
  HI = 'HI',
  PT = 'PT',
  ES = 'ES',
  TH = 'TH',
  AR = 'AR',
  FR = 'FR'
}

export const API_LANGUAGES_MAP: Record<SupportedLanguage, ApiLanguages> = {
  en: ApiLanguages.EN,
  hi: ApiLanguages.HI,
  pt: ApiLanguages.PT,
  es: ApiLanguages.ES,
  th: ApiLanguages.TH,
  ar: ApiLanguages.AR,
  fr: ApiLanguages.FR
};
